<template>
  <div class="jobsDeatils">
    <div class="jobsHeader bg_fff flex-c">
      <div class="flex1">
        <div class="jobTitle f_26 color_40 ellipsis font_w_b flexBox">
          <p class="f_26">{{jobData.job.job_post}}</p>
          <div class="money color_f64 f_24 font_w_b" v-if="jobData.job.salary">{{(jobData.job.annual_month_salary && jobData.job.annual_month_salary > 12) ? `${jobData.job.salary} · ${jobData.job.annual_month_salary}薪`: `${jobData.job.salary}`}}</div>
          <div class="money color_blue f_24 font_w_b" v-if="!jobData.job.salary">薪资不限</div>
        </div>
        <div class="text f_14 color_60 clearfix">
          <div class="icon fl"><span class="iconfont iconweizhi"></span>{{jobData.job.city || '职位不限'}}</div>

          <div class="icon fl" v-if="jobData.job.job_nature === '校招' && jobData.job.graduate_times.length"><span class="iconfont iconshijian"></span>{{ jobData.job.graduate_times | formatGraduationYear }}</div>

          <div class="icon fl"><span class="iconfont icongongzuojingyan"></span>{{!jobData.job.experience || jobData.job.experience === '不限' ? '经验不限' : (jobData.job.experience === '1年以下' ? '1年以内' : jobData.job.experience)}}</div>
          <div class="icon fl"><span class="iconfont iconjiaoyujingli"></span>{{jobData.job.degree_id ||jobData.job.degree || '学历不限'}}</div>
          <div class="icon fl" v-if="jobData.job.job_nature === '实习' && !!jobData.job.intern_duration"><span class="iconfont iconriqi"></span>{{jobData.job.intern_duration || '3个月'}}</div>
          <div class="icon fl" v-if="jobData.job.job_nature === '实习' && !!jobData.job.intern_frequency"><span class="iconfont iconshijian"></span>{{ !!jobData.job.intern_frequency ?  `${jobData.job.intern_frequency}天/周`: '5天/周'}}</div>
        </div>
        <div class="time f_14 color_60">{{jobData.job.end_at}} 到期</div>
      </div>
      <div class="templateButtons clearfix">
        <div class="flexBox alcen">
          <div class="hover">
            <div class="cancelButton f_14 text_center  blue_font_border shareButtonHover" v-if="jobStatus==='publish'" >分享</div>
            <div class="share-job-box" @click.stop>
              <div class="share-header">
                <i class="iconfont iconqiepian"></i>
                <span>微信扫码分享职位</span>
              </div>
              <qrcode-vue :value="`${origin}/jobs/${jobData.job.token}.html`" :size="175"/>
            </div>
          </div>

          <div class="confirmButton  text_center f_14" v-if="jobStatus==='publish'" @click="toSearchPage(jobData.job)">搜人才</div>

          <div class="confirmButton  text_center f_14 fl1" v-if="jobStatus==='draft'" @click="$router.push({path:`/talent/jobedit/${token}`})"><span class="el-icon-loading" v-if="checkFormState"></span>立即发布</div>
          <div class="confirmButton  text_center f_14 fl1" v-if="jobStatus!=='publish' && jobStatus!=='draft'" @click="$router.push({path:`/talent/jobedit/${token}`})"><span class="el-icon-loading" v-if="checkFormState"></span>重新发布</div>
        </div>

        <div class="titleButtons">
          <!-- 在线职位按钮 -->
          <div class="jobStatusButtons color60" v-if="jobData.job.status === 'publish'">
            <div class="shareButton flexBox alcen" @click="$router.push({path:`/talent/jobedit/${token}`})">
              <span class="iconfont iconbianji1 color40 iconcolor"></span>
              <p class="">编辑</p>
            </div>
            <div class="lines"></div>
            <div class="closeButton flexBox alcen" @click="offlineJobs(jobData.job)">
              <span class="iconfont iconxiaxian color40 iconcolor"></span>
              <p class="">下线</p>
            </div>
          </div>

          <!-- 草稿职位按钮 -->
          <div class="jobStatusButtons color60" v-if="jobData.job.status === 'draft'">
            <div class="shareButton flexBox alcen" @click="toSearchPage(jobData.job)">
              <span class="iconfont iconsourencai color40"></span>
              <p class="">搜人才</p>
            </div>
            <div class="lines"></div>
            <div class="closeButton flexBox alcen" @click="toRecommend(jobData.job)">
              <span class="iconfont iconkantuijian color40"></span>
              <p class="">看推荐</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="jobsCont clearfix" v-loading="isloading">
      <!-- 职位描述 -->
      <div class="leftCont fl bg_fff">
        <div class="leftContTitlte f_18 color_40">
          <span class="pr font_w_b">工作地点</span>
        </div>
        <div class="desc color_60 f_14">{{jobData.job.address || ''}}</div>

        <div class="leftContTitlte f_18 color_40">
          <span class="pr font_w_b">投递邮箱</span>
        </div>
        <div class="desc color_60 f_14">{{jobData.job.email || ''}}</div>

        <div class="leftContTitlte f_18 color_40">
          <span class="pr font_w_b">职位描述</span>
        </div>

        <div class="clearfix" v-if="jobData.job.job_tags && jobData.job.job_tags.length">
          <div class="tags fl f_12 color_9c" v-for="item in jobData.job.job_tags" :key="item">{{item}}</div>
        </div>
        <div class="desc color_60 f_14" v-html="replaceJd(jobData.job.jd)" ></div>

        <div class="leftContTitlte f_18 color_40" v-if="jobData.job.job_highlights && jobData.job.job_highlights.length > 0">
          <span class="pr font_w_b">职位亮点</span>
        </div>
        <div class="flex highlight-box" v-if="jobData.job.job_highlights && jobData.job.job_highlights.length > 0">
          <div class="highlight-item">
            {{ jobData.job.job_highlights.join('、')}}
          </div>
        </div>

        <template v-if="jobData.job.job_nature === '校招'">
          <div class="leftContTitlte f_18 color_40">
            <span class="pr font_w_b">投递截止</span>
          </div>
          <div class="desc color_60 f_14">{{jobData.job.deadline}}</div>
        </template>
      </div>
      <!-- 右侧信息 -->
      <div class="rightCont fr">
        <!-- 精准曝光 -->
        <div class="edit-show" v-if="exposure && Object.keys(exposure).length > 0">
          <p class="color_40 font_w_b f_18 mb24">精准曝光职位</p>
          <div class="edit-show-item color_40">
            <span class="color_9c">曝光职位：</span>
            {{jobData.job.job_post}}
          </div>
          <div class="edit-show-item color_40">
            <span class="color_9c">曝光时间：</span>
            {{calcTime(exposure.start_time,exposure.expired_time)}}
          </div>
          <div class="edit-show-item color_40">
            <span class="color_9c">学历/经验：</span>
            <span v-if="jobData.job.job_nature == '校招'">{{schooljob()}}</span>
            <span v-else>{{[exposure.degree_name,exposure.experience].filter(item => !!item).join(',') || '不限'}}</span>
          </div>
          <div class="edit-show-item color_40">
            <span class="color_9c">院校要求：</span>
            {{[...exposure.tag_names,...exposure.edu_names.map(item=>item._root)].join(',') || '不限'}}
          </div>
          <div class="edit-show-item color_40">
            <span class="color_9c">专业要求：</span>
              {{exposure.major_l1s.map(item=>item.name).join(',') || '不限'}}
          </div>
          <div class="line"></div>
          <div class="edit-show-btns">
            <p @click.stop="()=> {editDialogVisibile = true}" >修改曝光条件</p>
            <p @click.stop="showPayDialog(jobData.job)" >续费曝光时长</p>
          </div>
        </div>
        <!-- 公司信息 -->
        <div class="item-padding">
          <p class="color_40 font_w_b f_18 mb24">公司信息</p>
          <div class="topCont mb24">
            <a href="/talent/company" target="_blank" class="flexBox alcen">
              <div class="logoBorder">
                <img :src="companyInfo.logo" :alt="companyInfo.company_name" class="logo">
              </div>
              <div class="companyName f_14 color_40  ml16 fl1 text-el">{{companyInfo.company_name}}</div>
            </a>
          </div>
          <div class="color60">
            <div class="itemContent flexBox alcen text-el" v-if="companyInfo.industry_name || companyInfo.company_industry_cls_cn_name">
              <span class="iconfont iconbriefcase"></span>
              <p class="ml20 fl1">{{companyInfo.industry_name || companyInfo.company_industry_cls_cn_name}}</p>
            </div>
            <div class="itemContent flexBox alcen text-el" v-if="companyInfo.company_nature">
              <span class="iconfont icongrid"></span>
              <p class="ml20 fl1">{{companyInfo.company_nature}}</p>
            </div>
            <div class="itemContent flexBox alcen text-el" v-if="companyInfo.company_scale">
              <span class="iconfont iconusers"></span>
              <p class="ml20 fl1">{{companyInfo.company_scale}}</p>
            </div>
          </div>
          <div class="itemTitle f_14 color_40"><span class="iconfont iconfile-text"></span> 公司简介</div>
          <div class="itemContent desc f_14 color_60">{{companyInfo.description}}</div>
        </div>



        <!-- <template v-if="companyInfo.company_jobs.length">
          <div class="itemTitle f_14 color_40"><span class="iconfont iconbriefcase"></span> 在招职位</div>
          <div class="jobList">
            <template v-for="(item,index) in companyInfo.company_jobs">
              <a :href="`/talent/joblist/${item.token}`" target="_blank" class="f_14 ellipsis" :key="String(index)">{{item.title}}</a>
            </template>
          </div>
        </template> -->

      </div>
    </div>

    <!-- 弹出提示框 -->
    <tips-block v-if="tipsShowState" :tipsType="tipsType" :tipsState="tipsState" @hideTipsF="hideTips" @confirmButtonF="closeJob" />
    <!-- 修改曝光条件 -->
    <editPayDialog v-if="editDialogVisibile"
      type="top"
      payType="bJobTop"
      title="修改曝光条件"
      subtitle=""
      tipsText=""
      :jobArr="[jobData.job]"
      :jobIndex="0"
      @paidFunc="paidFuncEdit"
      @closeFunc="closeFuncEdit"
    />
    <!-- 精准曝光支付弹窗 -->
    <job-pay-dialog v-if="payDialogVisible"
        type="top"
        payType="bJobTop"
        title="精准曝光"
        subtitle=""
        tipsText="该类产品为数字化商业产品，一经售出不支持退款退货<br />为不影响推荐效果，购买后不建议更换职位类别"
        :jobArr="[jobData.job]"
        :jobIndex="0"
        :orderToken="orderToken"
        :orderPriceText="199"
        @paidFunc="paidFunc"
        @closeFunc="closeFunc" />
    <!-- 精准曝光火爆职位组合购买 -->
    <mix-job-pay v-if="mixPayDialogVisible"
        :jobTitle="mixJobTitle"
        :jobToken="mixJobToken"
        :job_nature="mixJobNature"
        :subtitle="mixJobEndTime"
        :nowOrderToken="mixOrderToken"
        :endTime="hotJobEndTime"
        :formData="jobData.job"
        @paidFunc="paidFunc"
        @closeFunc="closeFunc"
    />
  </div>
</template>

<script>
// 所有接口
import actions from '@/actions/index'
import { mapState, mapMutations } from 'vuex'
import { getCookieValue, get_tUser, toLogin } from '@/utils/utils'
import TipsBlock from '../components/TipsBlock';
import company_options from '@/utils/company_options'
import qrcodeVue from 'qrcode-vue'
import editPayDialog from '@/components/block/EditShowCondition.vue'
import jobPayDialog from '@/components/block/RecommandPay.vue'
import mixJobPay from '@/components/block/mixJobPay.vue'
const moment = require('moment')
export default {
  name: 'JobDetails',
  data(){
    return {
      origin: '',
      tipsType:1,
      tipsItem:{},
      token:'', //职位token
      jobStatus:'', //职位状态 //线上：publish，过期：expired ，草稿：draft
      jobData:{
        job:{}, //相似职位
      },
      formData:{},
      companyInfo:{},

      tipsState:1,//提示状态，1信息不完整，2超出最大数量，3重复职位
      tipsShowState:false,//是否展示提示框
      jobType:{
        '大专':'专科,本科,硕士,博士,MBA',
        '专科':'专科,本科,硕士,博士,MBA',
        '本科':'本科,硕士,博士,MBA',
        '硕士':'硕士,博士,MBA',
        '博士':'博士,MBA',
        'MBA':'MBA',
      },
      isloading:true,
      checkFormState:false,//表单发布状态
      exposure: null,  // 职位曝光条件
      editDialogVisibile: false, // 展示修改曝光条件弹框
      payDialogVisible: false,   // 购买职位曝光弹框
      mixPayDialogVisible: false, // 火爆职位加职位曝光组合购买
      orderToken: '',  // 精准曝光订单token
      mixJobToken: '',
      mixJobNature:'',
      mixJobTitle: '',
      mixJobEndTime: '',
      hotJobEndTime: '',
      mixOrderToken: '', // 火爆职位订单token
    }
  },
  computed:{
    ...mapState('block',['userInfoState'])
  },
  components:{
    'tips-block':TipsBlock,
    qrcodeVue,
    editPayDialog,
    jobPayDialog,
    mixJobPay
  },
  filters: {
    formatGraduationYear (yearArr) {
      if (!yearArr || !yearArr.length) return ''
      let newArr = yearArr.map(item => {
        return String(item).substring(2)
      })
      return newArr.join('、') + '届'
    }
  },
  async created(){
    let { token='' } = this.$route.params;
    this.token = token;
    this.getData();
    this.origin = window.location.origin;
    console.log(this.jobData)
  },
  methods:{
    paidFuncEdit() {
      console.log('paid');
    },
    paidFunc(){
      // 重新获取职位曝光
      this.getExpsureInfo()
      this.closeFunc()
      this.$message({
        message: '支付成功',
        type: 'success'
      })
    },
    // 设置校招时间
    schooljob() {
      let tempArr = this.exposure.end_at_list.map(item => {return String(item).substr(2) + '届' }).join('、')
      return this.exposure.degree_name + (this.exposure.degree_name ? ',' : '') + tempArr + '应届生'
    },
    // 获取职位曝光条件
    async getExpsureInfo(){
      if(this.$route.query.priority == 2) {
        let ress = await actions.recruit_infos.get_job_conditions({job_token: this.token})
        if(ress.code == 1000) {
          this.exposure = ress.data
        }
      }
    },
    // 关闭弹框回调
    closeFunc(){
      this.payDialogVisible = false
      this.mixPayDialogVisible = false
    },
    // 修改曝光条件回调
    async closeFuncEdit() {
      this.editDialogVisibile = false
      // 重新获取职位曝光
      this.getExpsureInfo()
    },
    // 显示支付弹窗
    async showPayDialog (data) {
      // 判断职位结束时间距离现在的时间是不是小于7天， 小于7天则弹出职位曝光和置顶组合购买弹框，否则就是单独购买精准曝光
      let endTimeCount = (new Date(data.end_at).valueOf() - new Date(moment().format('YYYY-MM-DD')).valueOf()) / (1000 * 60 * 60 * 24)
      if(endTimeCount < 7) {
        this.mixJobToken = data.token
        this.hotJobEndTime = data.end_at
        this.mixJobNature = data.job_nature
        this.mixJobEndTime = '有效期:' + data.end_at + '至' + moment(data.end_at).add(29, 'd').format('YYYY-MM-DD')
        this.mixJobTitle = data.job_post
        await this.createHotOrder(data)
        this.mixPayDialogVisible = true
        return
      }
      // 创建精准曝光订单
      this.createOrder(data.token)
      // 显示弹窗
      this.payDialogVisible = true
    },
    // 创建精准曝光订单
    async createOrder (token) {
      try {
        let params = {
          plan: 'top',
          job_token: token,
          start_time: moment().format('YYYY-MM-DD')
        }
        let res = await actions.recruit_infos.create_order(params)
        if (res.code === 1000) {
          // 获取订单 token
          this.orderToken = res.data.order_token
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 创建火爆职位订单
    createHotOrder (data) {
      return new Promise(async (resolve,reject) => {
        try {
          let params = {
            plan: 'hot',
            job_token: data.token,
            hot_start_time: moment(data.end_at).format('YYYY-MM-DD')
          }
          let res = await actions.recruit_infos.create_order(params)
            if (res.code === 1000) {
              // 获取订单 token
              this.mixOrderToken = res.data.order_token
            }
            resolve(res)
          } catch (e) {
            console.log(e)
            reject(e)
          }
      })
    },
    // 计算曝光时间
    calcTime(start,end) {
      return moment(start).format('MM月DD日') + '-' + moment(end).format('MM月DD日')
    },
    //下线职位二期确认弹框
    offlineJobs(item){
      this.tipsShowState = true;
      this.tipsType = 2;
      this.tipsState = 1;
      this.tipsItem = item
    },
    //关闭职位
    async closeJob(){
      let res = await actions.recruit_infos.put_recruit_status({
        status:'offline',
        token:this.tipsItem.token
      });
      if(res.code === 1000){
        this.$message({
          message: '职位关闭成功',
          type: 'success'
        });
        // 关闭弹窗
        this.hideTips();
        //重新获取数据
        this.getData();
      }else{
        //出错
        this.$message({
          message: res.message,
          type: 'error'
        });
      }
    },
    //去搜简历
    toSearchPage(item){
      let { job_post, degree, experience, city, id } = item;
      let query = {
        keyword: job_post,
        city: city||'',
        education: degree ? (degree==='学历不限' ? '' : this.jobType[degree])  : '',
        workYear: experience ? (experience==='经验不限' ? '' : (experience==='1年以下' ? '应届生' : experience) )  : '',
        job_id: id
      }
      this.$router.push({name:'talentSearchList',query})
    },
    //看推荐
    toRecommend(item) {
      this.$router.push({
        name:`talentRecommend`,
        query: {
          // 职位 token
          token: item.token,
          status:item.status
        }
      })
    },
    async getData(){
      let res = await actions.jobs.get_jobs_data(this.token);
      // 获取职位曝光信息
      this.getExpsureInfo()
      this.isloading = false;
      if(res.code === 1000){
        this.jobData = res.data;
        let { job } = res.data;
        //保存职位状态
        this.jobStatus = job.status;
        //如果不是自己的职位，不能进入这个页面
        if(!job.is_hr_edit){
          window.location.href = `/jobs/${this.token}.html`;
          return false;
        }
        if(job.company_token){
          this.getCompanyData({company_token:job.company_token});
        }
        //不是已发布职位，获取编辑详情
        if(job.status!=='publish'){
          this.getJobEditData();
        }

      }else{
        if(res.message === '无该职位'){
          setTimeout(() => {
            this.$router.replace({path:'/talent/joblist'})
          }, 1000);
        }
        this.$message({
          message: res.message,
          type: 'error'
        });
      }
    },
    // 获取编辑详情
    async getJobEditData(){
      let res = await actions.recruit_infos.get_recruit_edit(this.token);
      if(res.code === 1000){
        let { id, salary_type, job_nature, salary_min, salary_max, status, profession_id, job_post, jd, degree_id, job_city, delivery_email, experience_min, experience_max, city_names, city_ids, addresses, positions, job_tags,  profession_level1, profession_level2, company_token,  profession_level3, intern_duration, intern_frequency, job_highlights } = res.data.job;

        let cities = city_names&&city_names.length ? city_names[0] : '';
        city_ids = city_ids&&city_ids.length ? city_ids[0] : '';
        let address = addresses&&addresses.length ? addresses[0] : '';
        positions = addresses&&addresses.length&&positions&&positions.length ? positions[0] : '';
        job_tags = job_tags?job_tags:[];
        //状态
        this.formData = {
          id,
          salary_type: salary_type, //日薪/月薪
          salary_max: job_nature==='全职' ? parseInt(salary_max/1000) : salary_max, //薪水上限
          salary_min: job_nature==='全职' ? parseInt(salary_min/1000) : salary_min, //薪水下限
          experience:(!experience_min&&!experience_max) ? '' : `${experience_min||''},${experience_max||''}`, //,分开 以年为单位
          status:'publish',//publish draft 职位状态
          profession_id:profession_id||'',//profession id
          job_post:job_post||'',//职位名称
          jd:jd||'',//职位描述
          degree_id: degree_id||'',//学历id
          job_nature,//全职/兼职
          addresses: address,//工作地点
          cities,//工作地点
          city_ids,//工作地点
          positions,
          job_tags,
          email: delivery_email||'',
          intern_duration,
          intern_frequency,
          job_highlights
        };
      }else{
        if(res.code === 80135){
          //职位不存在
          this.$router.replace({path:'/talent/joblist'})
          return false;
        }
        this.$message({
          message: res.message,
          type: 'error'
        });
      }
    },
    // 检查表单完整性
    async checkForm(){
      if(this.checkFormState){
        return false;
      }
      let formData = JSON.parse(JSON.stringify(this.formData));
      let { company_name, logo, logo_hr, company_nature, company_scale, company_industry_id} = this.companyInfo;

      let formState = true;
      formData.job_post = formData.job_post.trim();
      let {
        job_post,//职位名称
        jd,//职位描述
        cities,//工作城市
        addresses,//工作地点
        positions, //工作地点定位
        email, //邮箱
        profession_id, //行业类型
        job_tags, //职位标签
        salary_min, //薪资
        intern_duration,
        intern_frequency,
        job_nature
      } = formData;

      if(!company_name || !(logo || logo_hr) || !company_nature || !company_scale || !company_industry_id){
        console.log('公司信息不完整');
        formState = false;
      }
      if(!job_post){
        console.log('请输入职位名称');
        formState = false;
      }
      if(!profession_id){
        console.log('请选择职位类别');
        formState = false;
      }
      if(!jd){
        console.log('请输入职位描述');
        formState = false;
      }else if(jd.length<50){
        console.log('职位描述不少于50字');
        formState = false;
      }
      if(!cities.length || !addresses.length || !positions.length){
        console.log('请输入工作地点');
        formState = false;
      }
      if(!email){
        console.log('请输入邮箱地址');
        formState = false;
      }
      if(!job_tags.length){
        console.log('请选择职位关键词');
        formState = false;
      }
      if(salary_min===''){
        console.log('请选择薪资范围');
        formState = false;
      }

      if(job_nature==='实习' && !intern_duration){
        console.log('实习时间');
        formState = false;
      }
      if(job_nature==='实习' && !intern_frequency){
        console.log('实习时间');
        formState = false;
      }

      if(!formState){
        console.log('缺少字段')
        this.$router.push({path:`/talent/jobedit/${this.token}?tipsState=1&tipsShowState=true`})
        return
      }
      formData.cities = formData.cities ? [formData.cities] : [];
      formData.city_ids = formData.cities ? [cities.id] : [];
      formData.addresses = formData.addresses ? [formData.addresses] : [];
      // formData.company_id = id;
      formData.companyInfo = this.companyInfo;
      // let company = {
      //   id,
      //   intro,
      //   logo,
      //   name,
      // }
      // formData.company = company;
      formData = this.checkVal(formData);
      this.checkFormState = true;
      let res = await actions.recruit_infos.put_recruit_status({
        status:'publish',
        token:this.token
        });
      this.checkFormState = false;
      if(res.code === 1000){
        this.$message({
          message: '职位发布成功',
          type: 'success'
        });
         setTimeout(() => {
          this.$router.push({name:'talentJobList'})
        }, 1000);
        return false;
      }else{
        if(res.code === 9000){
          // 超出数量限制
          this.tipsState = 2;
          this.tipsShowState = true;
          return false;
        }else if(res.code === 9001){
          // 重复职位
          this.tipsState = 3;
          this.tipsShowState = true;
          return false;
        }
        this.$message.error(res.message);
      }

    },
    //获取公司信息
    getCompanyData({company_token,brand_company_token}) {
      actions.company.get_company_companies(brand_company_token || company_token, { type: 'hr' }).then(res => {

        if (res.code === 1000) {
          let { token, company_full_name, company_tags, company_tags_hr, logo, logo_hr, size_max, size_min, industry_id, industry, company_type, description_hr, description, company_nick_name,industry_name } = res.data;
          //公司规模
          let size = ''
          if (size_max) {
            company_options.scale_options.forEach(item => {
              if (size_max <= item.max && !size) {
                size = item.label
              }
            })
          }
          //整理行业id
          if (industry_id && industry && industry.cn) {
            company_options.industry_options.forEach(item => {
              if (industry.cn === item.label) {
                industry_id = item.value
              }
            })
          }
          this.companyInfo = {
            company_token: token,
            company_name: company_full_name || '',
            company_nick_name: company_nick_name || '',
            company_scale: size,
            company_scale_min: size_min,
            company_scale_max: size_max,
            company_nature: company_type,
            company_tags: company_tags_hr && company_tags_hr.length ? company_tags_hr : company_tags,
            company_industry_id: industry_id,
            company_industry_cls_cn_name: industry && industry.cn ? industry.cn : '',
            logo: logo || '',
            logo_hr: logo_hr || '',
            description: description_hr || description,
            industry_name:industry_name,
          }
          if(brand_company_token){
            return
          }
          // if(brand_token){
          //   this.getCompanyData({brand_company_token: brand_token})
          // }
        }
      })
    },

    //去搜简历
    toSearch(){
      let { title, degree_id, experience, cities } = this.jobData.job;
      let query = {
        keyword: title,
        cities: cities||'',
        education: degree_id ? (degree_id==='学历不限' ? '' : this.jobType[degree_id])  : '',
        workYear: experience ? (experience==='经验不限' ? '' : (experience==='1年以下' ? '应届生' : experience) )  : ''
      }
      this.$router.push({name:'talentSearchList',query})
    },
    //整理描述html
    replaceJd(val) {
      if(!val){
        return '';
      }
      let arr = val.split('\n');
      let str = '';
      for (let i = 0; i < arr.length; i++) {
        str += `<p>${arr[i]}</p>`;
      }
      return str;
    },
    //过滤空字符串
    checkVal(formData){
      let formData2 = JSON.parse(JSON.stringify(formData));
      for(let k in formData){
        if(formData[k]==='' ||formData[k]===null){
          delete formData2[k]
        }
      }
      return formData2

    },
    //隐藏提示
    hideTips(){
      this.tipsShowState = false;
      this.tipsType = 1
      this.tipsItem = {}
    },
  }
}
</script>
<style lang="scss" scoped>
 .highlight-box{
   flex-wrap: wrap;
 }
.highlight-item{
  font-size: 14px;
  font-weight: 400;
  color: #606060;
  line-height: 32px;
}
.text-el{
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.fl1{
  flex: 1
}
@import './Index.scss';

</style>
